<button [ngClass]="{'btn btn-outline': outline, 'btn btn-cancelar': cancelar, 'btn button-primary': !outline, 'disabled':disabled, 'btn-acceso':btnAcceso, 'btn-outlineYellow': outlineYellow, 'btn-outlineRed': outlineRed}" (click)="clicked()">
  <span [ngClass]="{'btn-icon': titulo!='', 'btn-icon-no-titulo': titulo==''}" *ngIf="icono">
    <svg [class]="icono" [ngClass]="{'icono-outlineRed': outlineRed}">
      <use [attr.xlink:href]="icono|iconoRef"></use>
    </svg>
  </span>
  <span class="btn-text">{{titulo}}</span>
</button>
